export default __webpack_public_path__ + "static/media/honeymoon6.ffc84ffa.webp";